import { SHEET_ACTION_PROGRAMMATICALLY } from "../event/event.activation";
import { type ActivationAction, type ActivationReason } from "./stack.utils";

const stackData = $state<{
  prev: string[];
  current: string | null;
  previous: string | null;
  visited: string[];
  reason: ActivationReason;
  contentChange: boolean;
  isPushing: boolean;
  isPopping: boolean;
  popLength: number;
  action: ActivationAction;
}>({
  prev: [],
  current: null,
  previous: null,
  visited: [],
  reason: "open-close",
  contentChange: false,
  isPushing: false,
  isPopping: false,
  popLength: 0,
  action: SHEET_ACTION_PROGRAMMATICALLY,
});

/**
 *
 */
export const stack = stackData as Readonly<typeof stackData>;

export const computeReason = <IsChange extends boolean>(
  isChange: IsChange,
): IsChange extends true ? "content-switch" : "open-close" =>
  (isChange ? "content-switch" : "open-close") as never;

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const computePopLength: (current: string | null, prev: string[]) => number = (
  current,
  prev,
) => (current !== null ? prev.length + 1 : prev.length);

export const updateDerived = (): typeof stack => {
  /*                                                                 */
  stackData.previous = stackData.prev.at(-1) ?? null;

  /*                                                                                                  */
  if (stackData.previous && stackData.current) {
    stackData.contentChange = true;
  }
  /*                                                                                  */
  /*                */
  else if (!stackData.isPushing && !stackData.isPopping) {
    stackData.contentChange = false;
    stackData.popLength = 0;
  }
  /*                                                                  */
  /*                              */
  else if (!stack.current) {
    stackData.contentChange = false;
  }

  /*                                                    */

  /*                                               */
  stackData.reason = computeReason(stackData.contentChange);

  return stack;
};

/**
 *
 *
 */
export const commitPopPush = (): typeof stack => {
  stackData.isPushing = false;
  stackData.isPopping = false;
  stackData.action = SHEET_ACTION_PROGRAMMATICALLY;

  return updateDerived();
};

export const clearStack = (): typeof stack => {
  stackData.prev = [];
  stackData.current = null;
  stackData.visited = [];

  return commitPopPush();
};

export const restoreStack = (
  currentId: string | undefined,
  currentPrev: string[] | undefined,
  action: ActivationAction = SHEET_ACTION_PROGRAMMATICALLY,
): typeof stack => {
  stackData.current = currentId ?? null;
  stackData.prev = currentPrev ? [...currentPrev] : [];
  stackData.action = action;

  return updateDerived();
};

export const pushStack = (id: string, action: ActivationAction): typeof stack => {
  const { prev, current } = stackData;
  if (current === id) return stackData; /*                  */

  /*          */
  if (current !== null) prev.push(current);
  stackData.current = id;
  stackData.isPushing = true;
  stackData.action = action;

  return updateDerived();
};

export const popStack = (action: ActivationAction): typeof stack => {
  const { visited, prev, current } = stackData;

  if (current === null) {
    if (prev.length > 0) {
      /*             */
      return clearStack();
    }

    /*              */
    return stack;
  }

  /*                      */
  visited.unshift(current);
  /*                    */
  stackData.current = prev.pop() ?? null;
  stackData.isPopping = true;
  stackData.action = action;
  stackData.popLength = 1;

  return updateDerived();
};

export const popStackAll = (action: ActivationAction): typeof stack => {
  const { visited, prev, current } = stackData;

  /*                              */
  if (current === null) return stack;

  /*                                                */
  /*                                      */
  const popLength = computePopLength(stackData.current, prev);

  visited.unshift(current);
  visited.unshift(...prev.splice(0));

  stackData.current = null;
  stackData.isPopping = true;
  stackData.action = action;
  stackData.popLength = popLength;

  return updateDerived();
};

export const deleteStackItem = (id: string): typeof stack => {
  /*                          */
  if (stackData.current === id) return clearStack();

  if (stackData.prev.includes(id)) stackData.prev.splice(stackData.prev.indexOf(id), 1);
  if (stackData.visited.includes(id)) stackData.visited.splice(stackData.visited.indexOf(id), 1);
  stackData.popLength = computePopLength(stackData.current, stackData.prev);

  return updateDerived();
};

export const getStackAllIds = (): string[] => {
  const { prev, current, visited } = stackData;
  /*                                                       */
  return [...new Set([...prev, current, ...visited].filter((id): id is string => id !== null))];
};
